<template>
  <BaseView title="Alerts">
    <template #content>
      <div style="height: 100%; position: relative">
        <div class="categories-drawer">
          <CategoriesDrawer
            :onSelectCategory="onSelectCategory"
            :onSaveAlerts="onSaveAlerts"
          />
        </div>

        <div class="alert-list-view">
          <AlertsLoadingView v-if="fetchLoading" />
          <AlertsErrorView
            v-else-if="fetchRequestFailed"
            icon="mdi-alert-circle-outline"
            title="No Alerts Found"
            message="An error occurred while fetching alerts."
          />
          <VesselAlertsSuccessView v-else />
        </div>
      </div>
    </template>
  </BaseView>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import CategoriesDrawer from "./components/CategoriesDrawer.vue";
import VesselAlertsSuccessView from "./SuccessView.vue";
import AlertsLoadingView from "../components/LoadingView.vue";
import AlertsErrorView from "../components/ErrorView.vue";
import BaseView from "../../components/BaseView.vue";

export default {
  name: "VesselAlertsView",
  components: {
    CategoriesDrawer,
    VesselAlertsSuccessView,
    AlertsLoadingView,
    AlertsErrorView,
    BaseView,
  },
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    ...mapState("alerts", ["fetchLoading", "alerts"]),
    ...mapGetters("alerts", ["fetchRequestFailed"]),
  },
  methods: {
    ...mapActions("alerts", ["fetchAlerts"]),
    onSelectCategory(categoryId) {
      this.$store.commit("alerts/SET_SELECTED_CATEGORY", categoryId);
    },
    async onSaveAlerts() {
      await this.$store.dispatch("alerts/updateAlerts", this.alerts);
    },
  },
  async mounted() {
    this.$store.commit("alerts/RESET_STATE");
    await this.fetchAlerts(this.$route.params.vessel);
  },
  watch: {
    async $route(next, previous) {
      const previousVesselName = previous.params.vessel;
      const nextVesselName = next.params.vessel;
      if (previousVesselName != nextVesselName) {
        await this.fetchAlerts(this.$route.params.vessel);
      }
    },
  },
};
</script>

<style scoped>
.categories-drawer {
  width: 400px; /* Set a width that fits your needs, adjust as necessary */
  background-color: var(--color-bg);
}

.v-list {
  background-color: var(--color-surface);
}

.v-navigation-drawer {
  background-color: var(--color-surface) !important;
}

/* Ensure the map expands to fill the available space */
.alert-list-view {
  position: absolute;
  left: 400px;
  background-color: var(--color-primary);
  width: calc(100% - 400px);
  height: 100%;
}
</style>
  

  
  